import _ from "lodash";

export {
    processDesignVariantStatistics,
    prepareDesignName,
    prepareSEODesignName,
}

const processDesignVariantStatistics = (designDetail) => {
    const variantsByStatusMap = _.groupBy(designDetail.variants, 'status');
    designDetail.statistics = {
        readyToPublish: variantsByStatusMap['ready-to-publish']?.length || 0,
        inDesign: variantsByStatusMap['in-design']?.length || 0,
        published: variantsByStatusMap['published']?.length || 0,
        batches: designDetail.batches?.length || 0,
    };
}

const prepareDesignName = (pod, theme, quote, parentProduct) => {
    let designNameList = [];

    if (!_.isEmpty(quote)) {
        designNameList.push(quote.startText);
    }

    if (!_.isEmpty(theme)) {
        designNameList.push(theme.startText);
    }

    if (!pod.ignoreProductTypeInDesignName) {
        if (!_.isEmpty(parentProduct)) {
            designNameList.push(parentProduct.name);
        }
    }

    return _.join(designNameList, ' | ');
}

const prepareSEODesignName = (pod, theme, quote, parentProduct) => {
    let seoDesignNameList = [];

    if (!pod.ignoreProductTypeInDesignName) {
        if (!_.isEmpty(parentProduct)) {
            seoDesignNameList.push(parentProduct.name);
        }
    }

    if (!_.isEmpty(quote)) {
        seoDesignNameList.push(quote.startText);
    }

    if (!_.isEmpty(theme)) {
        seoDesignNameList.push(theme.startText);
    }

    return _.join(seoDesignNameList, ' | ');
}
